import http from '@/services/api/http';

export default {
  getOrderBook(contractId) {
    return http.get(`api/Trade/${contractId}/OrderBook`);
  },
  postConfirmTrade(payload) {
    return http.post('api/Trade/ConfirmTrade', payload); // Confirm trade create order for confirmation
  },
  postSubmitTrade(payload) {
    return http.post('api/Trade/SubmitTrade', payload); // Submit trade create order without confirmation
  },
  postCancelAllOffers(contractId, payload) {
    return http.post(`api/Trade/CancelAllOffers/${contractId}`, payload);
  },
  postCancelOffer(offerId) {
    return http.post(`api/Trade/CancelOffer/${offerId}`);
  },
  getOrderBookTradeInfo(contractId, tradeType, price) {
    return http.get(`api/Trade/${contractId}/OrderBook/${tradeType}/${price}`);
  },
};
